<script>
    import { getExplaination } from '../helpers'

    export let expression

    $: explaination = expression ? getExplaination(expression) : expression
</script>

<style>
    div {
        min-height: 1.75rem;
    }

    h3 {
        font-size: 1.075rem;
        font-weight: 500;
        line-height: 1.2;
        color: var(--white);
        margin: 0 0 -2px;
        padding: 0.25rem 0.5rem;
        background-color: var(--blue);
        display: inline-block;
        border-radius: 5px 5px 0 0;
        max-width: calc(100% - 2rem);
        word-spacing: -0.075em;
    }

    @media (min-width: 50rem) {
        h3 {
            max-width: calc(80% - 2rem);
        }
    }
</style>

<div>
    {#if explaination}
        <h3>{explaination}</h3>
    {/if}
</div>
